import { Button, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../../../../reusable-components/iconify';

InvoiceBookingTypesToolbar.propTypes = {
  setOpenForm: PropTypes.func,
};

export default function InvoiceBookingTypesToolbar({ setOpenForm }) {

  return <Stack direction="row" spacing={1}>
    <Button
      variant="contained"
      size="small"
      color="secondary"
      onClick={() => setOpenForm(true)}
      startIcon={<Iconify icon="eva:plus-outline" />}
    >
      Add Booking Type
    </Button>
    <Button
      variant="outlined"
      size="small"
      color="secondary"
      onClick={() => window.open(`/Api/Admin/InvoiceBookingType/DownloadBookingTypes`, '_blank')}
      startIcon={<Iconify icon="file-icons:microsoft-excel" />}
    >
      Download
    </Button>
  </Stack>;
};
